import { render, staticRenderFns } from "./PizzaPage.vue?vue&type=template&id=46ad25eb&scoped=true&"
import script from "./PizzaPage.vue?vue&type=script&lang=js&"
export * from "./PizzaPage.vue?vue&type=script&lang=js&"
import style0 from "./PizzaPage.vue?vue&type=style&index=0&id=46ad25eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ad25eb",
  null
  
)

export default component.exports